import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getRequest, postRequest } from 'utils/api';
import { closeModal, openModal, setShouldRefresh } from 'features/utilsSlice';
import useModalOpen from 'hooks/useModalOpen';
import CenteredDialog from 'components/CenteredDialog';

const GigInvitationDialog = ({ setData, setMenuItems }) => {
  const dispatch = useDispatch();
  const { gig, profile } = useSelector(state => state.utils.modalData['Request Gig']);
  const openProfile = useModalOpen('Profile');
  const openFullProfile = useModalOpen('Full Profile');
  const [suggestedPrice, setSuggestedPrice] = useState(null);

  const handleDialogClose = () => dispatch(closeModal('Request Gig'));

  const handleSubmit = (message, price) => {
    postRequest({
      endpoint: 'gig_invitations',
      data: {
        gig_invitation: {
          gig_id: gig.id,
          profile_id: profile.id,
          invitation_message: message,
          price: price,
        },
      },
    })
      .then(() => {
        if (setData) {
          setData(prevData => prevData.filter(d => d.id !== profile.id));
        }

        if (setMenuItems) {
          setMenuItems(prevItems => prevItems.filter(i => i.id !== gig.id));
        }

        dispatch(setShouldRefresh(gig.id));
        if (openProfile) dispatch(closeModal('Profile'));
        if (openFullProfile) dispatch(closeModal('Full Profile'));
        handleDialogClose();

        dispatch(openModal({ name: 'Success Gig' }));
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (!gig?.id || !profile?.id) return;

    getRequest({
      endpoint: `gigs/${gig.id}/profile_price_estimate`,
      query: { profile_id: profile.id },
    })
      .then(res => setSuggestedPrice(res.price))
      .catch(() => {});
  }, [gig?.id, profile?.id]);

  if (!suggestedPrice) return null;

  return (
    <CenteredDialog
      modalName="Request Gig"
      title={`Invite ${profile?.display_name} to ${gig?.title}`}
      placeholder="It's a good idea to give the influencer a short personal note to accompany the gig invitation. Why should they accept this gig?"
      handleSubmit={handleSubmit}
      handleDialogClose={handleDialogClose}
      defaultPrice={suggestedPrice}
      priceFieldProps={{
        label: 'Offer',
        min: suggestedPrice,
        max: 100000,
        disabled: true,
        helperText: 'This is how much the offer will be for',
        blackHelperText: true,
      }}
      priceField
      alwaysEnabled
    />
  );
};

export default GigInvitationDialog;
